import { ref } from 'vue'
import { defineStore } from 'pinia'
// import { useI18n } from "vue-i18n";

export const useServiceProviderSearchStore = defineStore('service_provider_search', () => {
    // I18n
    // const { t } = useI18n()

    // Stores
    // const authenticationStore = useAuthenticationStore()

    // Variables
    const defaultFilters = {
        query_string: "",
        location: null,
        type: {
            dealership: false,
            chain: false,
            independent: false
        }
    }

    const filters = ref(structuredClone(defaultFilters))

    // Methods

    function buildQueryString(page = 1) {
        if(!filters.value.location){
            return null;
        }

        const url = new URL(`${import.meta.env.VITE_BACKEND_URL}/api/v2/service_providers/search`)

        url.searchParams.append("per_page", 10)
        url.searchParams.append("page", page)

        if(page > 1){
            url.searchParams.append("query[sponsored_scope_tier_eq]", 0)
        }

        url.searchParams.append("latitude", filters.value.location.latitude)
        url.searchParams.append("longitude", filters.value.location.longitude)

        if(filters.value.query_string) {
            url.searchParams.append("query[name_cont]", filters.value.query_string)
        }

        if(filters.value.type.dealership){
            url.searchParams.append("query[service_chain_type_in][]", 'dealership')
        }

        if(filters.value.type.chain){
            url.searchParams.append("query[service_chain_type_in][]", 'chain')
        }

        if(filters.value.type.independent){
            url.searchParams.append("query[service_chain_type_in][]", 'independent')
        }

        return url.href
    }

    const $reset = () => {
        filters.value = ref(structuredClone(defaultFilters))
    }

    return {
        filters,
        $reset,
        buildQueryString
    }

}, {
    persist: {
        storage: sessionStorage,
    }
});